import { app } from '../../../../app';
import { Controller } from './saml-metadata.controller';

app.component('samlMetadata', {
    bindings: {
        metadata: '<',
    },
    controller: Controller,
    templateUrl: require('./saml-metadata.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/saml-metadata/saml-metadata.component.js